const t = "_tag_1w35i_2", l = "_small_1w35i_33", _ = "_solid_1w35i_41", o = "_outlined_1w35i_45", i = "_fullWidth_1w35i_50", s = "_tagButton_1w35i_56", a = {
  tag: t,
  default: "_default_1w35i_27",
  small: l,
  solid: _,
  outlined: o,
  fullWidth: i,
  tagButton: s
};
export {
  a as default,
  i as fullWidth,
  o as outlined,
  l as small,
  _ as solid,
  t as tag,
  s as tagButton
};
//# sourceMappingURL=Tag.module.css.js.map
